// University-style course numbers: 2-letter subject + 3 digits (100s foundation, 200s advanced/specialist).
// Keyed by learning-path id; SLUG_TO_PATH maps /courses/<slug> pages onto those ids.
export const COURSE_CODES = {
  'critical-thinking-foundations': 'CT101',
  'decision-making': 'CT102',
  'media-information-literacy': 'CT103',
  'argument-and-debate': 'CT201',
  'epistemic-forensics': 'CT202',
  'semantic-architecture': 'CT203',
  'public-speaking-mastery': 'PS101',
  'death-of-performed-perfection': 'PS201',
  'dialectic-vs-dogma': 'PS202',
  'rhetoric-of-authority': 'PS203',
  'algorithmic-bias-legal-tech': 'PS204',
  'cognitive-behavioural-rhetoric': 'PS205',
  'affective-containment': 'LG201',
  'psychological-disconnect': 'LG202',
  'rhetoric-persuasion': 'RH101',
  'advocacy': 'RH102',
  'rhetorical-modes': 'RH201',
  'nonviolent-communication': 'CM101',
  'negotiation-skills': 'CM102',
  'conflict-management': 'CM103',
  'group-communication': 'CM104',
  'workplace-cognition': 'CM201',
  'leadership-styles': 'LD101',
  'philosophy-thinking': 'PH101',
  'trivium': 'TR101',
  'english-language': 'TR101',
  'trivium-verbs': 'TR102',
  'writing-skills': 'TR103',
  'introduction-to-logic': 'TR104',
};

const SLUG_TO_PATH = {
  'critical-thinking': 'critical-thinking-foundations',
  'biases': 'media-information-literacy',
  'public-speaking': 'public-speaking-mastery',
  'rhetoric': 'rhetoric-persuasion',
  'philosophy': 'philosophy-thinking',
  'english-grammar': 'english-language',
  'introduction-to-writing': 'writing-skills',
};

export const codeForPath = (pathId) => COURSE_CODES[pathId] || null;
export const codeForSlug = (slug) => COURSE_CODES[SLUG_TO_PATH[slug] || slug] || null;
export const codeForLink = (link = '') => (link.startsWith('/courses/') ? codeForSlug(link.split('/')[2]) : null);

// Code for any URL: /courses/<slug>/... or /learning-path/<pathId>/...
export const codeForUrl = (pathname = '') => {
  const [, root, id] = pathname.split('/');
  if (root === 'courses') return codeForSlug(id);
  if (root === 'learning-path') return codeForPath(id);
  return null;
};
